export default __webpack_public_path__ + "static/emergency-daccbcfd3457835f286563ef32a111f6.svg";